import * as t from "react";
import m from "react-dom";
import { P as u } from "./index.DMLWxr4u.js";
import { j as c } from "./jsx-runtime.DGlMoOmv.js";
var f = globalThis?.document ? t.useLayoutEffect : () => {
}, l = "Portal", p = t.forwardRef((r, e) => {
  const { container: a, ...s } = r, [n, i] = t.useState(!1);
  f(() => i(!0), []);
  const o = a || n && globalThis?.document?.body;
  return o ? m.createPortal(/* @__PURE__ */ c.jsx(u.div, { ...s, ref: e }), o) : null;
});
p.displayName = l;
export {
  p as P
};
//# sourceMappingURL=index.RcubEhGW.js.map
